import { Injectable } from '@angular/core';

import { LocalStoreService } from '@frontend/vanilla/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { debounceTime, filter, map, withLatestFrom } from 'rxjs';

import { QuickBetActions } from '../../quick-bet/quick-bet-actions';
import { RewardTokensActions } from '../actions';
import { RewardTokensStore } from '../reward-tokens-store.model';
import { rewardTokensOnBoardingSelector, selectRewardTokensOnboardingRewardSelectorVisible } from '../selectors';
import { RewardTokensEffects } from './reward-tokens.effects';

@Injectable()
export class RewardTokensOnBoardingEffects {
    constructor(
        private actions$: Actions,
        private store: Store,
        private localStore: LocalStoreService,
    ) {}

    onboardingPopupVisibilityEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(...RewardTokensEffects.BETSLIP_CONTEXT_CHANGE_ACTIONS, RewardTokensActions.notifyEligibilityUpdated),
            debounceTime(3),
            withLatestFrom(this.store.select(selectRewardTokensOnboardingRewardSelectorVisible)),
            filter(([, isSelectorVisible]) => isSelectorVisible && !this.localStore.get<RewardTokensStore>('rewardTokens')?.onboardingMessageShown),
            map(() => RewardTokensActions.showOnboarding()),
        );
    });

    hideOnBoarding$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(RewardTokensActions.openDialog, RewardTokensActions.showOverlayInfo, QuickBetActions.hideQuickBet),
            withLatestFrom(this.store.select(rewardTokensOnBoardingSelector)),
            filter(
                ([, onboardingState]) => onboardingState.visible && !!this.localStore.get<RewardTokensStore>('rewardTokens')?.onboardingMessageShown,
            ),
            map(() => RewardTokensActions.hideOnboarding()),
        );
    });
}
